import * as React from 'react';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { CartModel, ConfigurationModel, LineModel, CartPart } from 'franke-trough-dependencies';
import { find as _find } from 'lodash';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './checkout.messages';
import { CutOutLabel } from '../Inputs/Recesses/CutOutDisposalSelection';

export interface  RecessesPartialCheckoutProps {
  checkout: GlobalPrivateState['checkout'];
  configuration: GlobalPrivateState['configuration'];
}

export class RecessesPartialCheckout extends React.Component<RecessesPartialCheckoutProps, any> {
  public render() {
    const builtInParts = this.configuration && this.configuration.builtInParts;
    return builtInParts && (
      <div className="recesses-partial-line">
        <span className="configuration-name"><FormattedMessage {...MESSAGES.builtInPartsTitle} /></span>
        <ul>
          {this.tapHole && builtInParts && builtInParts.tapHole && (
            <li>
              <FormattedMessage {...MESSAGES.builtInPartsDrillHoleForTaps} values={{qty: this.tapHole.qty}} />
            </li>
          )}
          {this.soapDispenser && builtInParts && builtInParts.soapDispenserHole && (
            <li>
              <FormattedMessage {...MESSAGES.builtInPartsDrillHoleForSoap} values={{
                qty: this.soapDispenser.qty,
                name: builtInParts.soapDispenserHole
              }} />
            </li>
          )}
          {this.cutOuts && builtInParts && builtInParts.cutOutDisposals && (
            <li>
              <FormattedMessage {...MESSAGES.builtInPartsCutOut} values={{
                qty: this.cutOuts.qty,
                name: builtInParts.cutOutDisposalsType && <CutOutLabel value={builtInParts.cutOutDisposalsType} /> || '',
              }} />
            </li>
          )}
          {this.paperTowelDispenser && builtInParts && builtInParts.tissueDispenser && (
            <li>
              <FormattedMessage {...MESSAGES.builtInPartsCutOutPaperTowelDispenser} values={{
                qty: this.paperTowelDispenser.qty,
                name: <CutOutLabel value={'PROVIDER'} /> || '',
              }} />
            </li>
          )}
          {this.cosmeticTissueDispenser && builtInParts && builtInParts.tissueDispenser && (
            <li>
              <FormattedMessage {...MESSAGES.builtInPartsCutOutTissueDispenser} values={{
                qty: this.cosmeticTissueDispenser.qty,
              }} />
            </li>
          )}
          {this.towelRail && (
            <li>
              <FormattedMessage {...MESSAGES.builtInPartsCutOutTowelRail} values={{
                qty: this.towelRail.qty,
              }} />
            </li>
          )}
        </ul>
      </div>
    ) || null;
  }

  private getLinePartByKey(key: string): LineModel | undefined {
    if (!this.checkout) {
      return;
    }
    
    const builtInParts = this.checkout.lines && this.checkout.lines.builtInParts;
    if (!builtInParts) {
      return;
    }
    const consoles = _find(builtInParts, ass => ass.part && (ass.part as CartPart).key === key);
    return consoles ? consoles : undefined;
  }

  private get tapHole(): LineModel | undefined {
    return this.getLinePartByKey('taphole');
  }

  private get soapDispenser(): LineModel | undefined {
    return this.getLinePartByKey('soap_dispenser');
  }

  private get cutOuts(): LineModel | undefined {
    return this.getLinePartByKey('cut_out');
  }

  private get cosmeticTissueDispenser(): LineModel | undefined {
    return this.getLinePartByKey('tissue_dispenser');
  }

  private get paperTowelDispenser(): LineModel | undefined {
    return this.getLinePartByKey('paper_towel_dispenser');
  }

  private get towelRail(): LineModel | undefined {
    return this.getLinePartByKey('towel_rail');
  }

  private get configuration(): ConfigurationModel | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result;
  }

  private get checkout(): CartModel |undefined {
    const { checkout } = this.props;
    return checkout && checkout.result;
  }
}

export const ReccessesPartialCheckoutComponent = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  checkout: state.checkout,
}))(RecessesPartialCheckout);

export default ReccessesPartialCheckoutComponent;